"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = csrf;

var _url = _interopRequireDefault(require("url"));

// IE 11 默认缓存了 GET 请求的结果，通过添加时间戳来避免缓存
var timestampKey = '__noCache__';

function csrf(url, options) {
  var newUrl = url;
  var method = options.method && options.method.toUpperCase();

  if (url && method === undefined || method === 'GET' || method === 'HEAD') {
    if (options.cache === 'no-cache' || options.cache === 'no-store') {
      var urlObj = _url.default.parse(url, true);

      urlObj.search = '';
      urlObj.query[timestampKey] = new Date().getTime();
      newUrl = _url.default.format(urlObj);
    }
  }

  return {
    url: newUrl
  };
}